import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {GenericDocContainerModel} from '../../../../../../models/aggregates/generic_doc';

@Injectable({providedIn: 'root'})
export class CustomerPurchaseInvoiceService extends BaseApiTemplateService<GenericDocContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
    Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-purchase-invoices';
    this.httpClient = http;
  }
}
